var SelectComponent = $.extend({/* SelectComponent */}, BaseComponent, {

	componentSelector: '.custom-select-control',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},

	binding: function(index, element) {
		var optionValue = '';
		var optionLngKey = '';
		var chooseLngKey = '';
		var displayHTML = '';
		var optionHTML = '';
		var output = '';
		var labelSelected = '';
		
		$(element).find('select option').each((function(indx, option) {
			optionValue = $(option).attr('value');
			optionLngKey = $(option).attr('lng-key');

			var selectedClass = '';
			
			if (!optionValue == '') {
				$(option).is(':selected') ? selectedClass += 'selected' : selectedClass += '';
				optionHTML += '<div class="select-option select-option-bg select-option-label select-option-bg-hover select-option-border '+selectedClass+'" lng-key="'+optionLngKey+'"title="'+optionValue+'">'+$(option).text()+'</div>\n';
			}
			else if (optionValue == '') {
				chooseLngKey = $(option).attr('lng-key');
			}

			if ($(option).is(':selected')) {
				labelSelected = $(option).text();
			}

		}).bind(this));

		displayHTML += '<div class="optionSelected form-input-text form-input-bg form-input-border"><span class="form-input-text" lng-key="'+chooseLngKey+'">'+labelSelected+'</span><i class="icon-desplegable form-text"></i></div>';

		output += displayHTML;
		output += '<div class="form-select form-input-text form-input-bg form-input-border">\n';
		output += optionHTML;
		output += '</div>';
	
		$(element).find('select').before(output);

		$(element).find('.optionSelected').click((function(event) {
			$(event.currentTarget).parents(this.componentSelector).find('.form-select').slideToggle(500);
		}).bind(this));

		$(element).find('.select-option').click((function(event) {
			var optionValue = $(event.currentTarget).text();

			$(event.currentTarget).parents(this.componentSelector).find('.form-select').slideToggle(500);

			$(event.currentTarget).parents(this.componentSelector).find('.optionSelected span').text(optionValue);

			var updatedLngKey = $(event.currentTarget).parents(this.componentSelector).find('select option').filter(function() { 
			    return ($(this).val() == optionValue);
			}).attr('lng-key');

			$(event.currentTarget).parents(this.componentSelector).find('.optionSelected span').attr('lng-key', updatedLngKey);

			$(event.currentTarget).parents(this.componentSelector).find('select option').filter(function() { 
			    return ($(this).val() == optionValue);
			}).prop('selected', 'selected');			

			$(event.currentTarget).parents(this.componentSelector).find('.select-option').removeClass('selected');
			$(event.currentTarget).addClass('selected');
		}).bind(this));
	}
})